<template>
  <el-dialog
    :title="dept_id?'编辑部门':'添加部门'"
    :visible.sync="show"
    width="50%"
    @close="onClose"
    :close-on-click-modal="false"
  >
    <div class="column-view">
      <el-form label-position="right" label-width="100px">
        <el-form-item label="部门名称">
          <el-input placeholder="请输入部门名称" v-model="dept_name"></el-input>
        </el-form-item>
        <el-form-item label="职务/人员">
          <div class="column-view">
            <div class="row-view margin-bottom-10" v-for="(item,index) in posts" :key="index">
              <div class="flex-1">
                <select-posts :ref="'selectPosts'+index" :post="item.post_id" :type="dept_level" style="width: 100%"
                              :index="index" @onSelectPostChanged="onSelectPostChanged"></select-posts>
              </div>
              <div class="flex-2 margin-left-10">
                <select-employee :ref="'selectEmployee'+index" style="width: 100%;" :employees="item.employee_ids"
                                 :index="index" @onSelectEmployeeChanged="onSelectEmployeeChanged"></select-employee>
              </div>
              <el-button type="danger" icon="el-icon-delete" size="mini" circle style="margin-left: 10px"
                         @click="onDeletePost(index)"></el-button>
            </div>

            <div>
              <el-button type="text" size="normal" @click="onAddPostClick()">＋ 添加职务</el-button>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="()=>{this.show=false}">取 消</el-button>
      <el-button type="primary" @click="onSaveClick()" >保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import selectPosts from "@/views/setting/departmentManagement/components/selectPosts";
import selectEmployee from "@/views/setting/departmentManagement/components/selectEmployee";

export default {
  name: "createEditPartmentDialog",
  //是否是编辑 、 类型 1：局级  2：部门级
  props: ['edit', 'type'],
  components: {selectPosts, selectEmployee},
  data() {
    return {
      show: false,
      dept_name: '',
      dept_id: '',
      posts: [],
      dept_level: '2',//默认部门级
    }
  },
  methods: {
    onSaveClick(){
      if(!this.dept_name){
        return this.$commonUtils.showMessage('请输入部门名称','error')
      }
      if(!this.posts.length){
        return this.$commonUtils.showMessage('请添加职务与人员','error')
      }

      for( const item of this.posts){
        if(!item.post_id||item.employee_ids.length===0){
          return this.$commonUtils.showMessage('请完善职务与人员信息','error')
        }
      }

      let request_data={
        dept_name:this.dept_name
      }
      this.posts.forEach((item,index)=>{
        request_data['items['+index+'][post_id]']=item.post_id;
        item.employee_ids.forEach((employee,position)=>{
          request_data['items['+index+'][employee_id]['+position+']']=employee
        })
      })

      if(this.dept_id){
        request_data['id']=this.dept_id
      }


      this.$prompt('确认保存当前部门信息', '保存部门信息', {
        confirmButtonText: '保存',
        cancelButtonText: '取消',
        type: 'warning',
        showInput: false,
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true
            instance.confirmButtonText = '保存中...'
            this.http.api(this.dept_id?'editDepartment':'addDepartment', request_data).then(res => {
              if (res.status) {
                instance.confirmButtonLoading = false
                instance.confirmButtonText = '保存'
                done()
                this.show=false;
                this.$commonUtils.showMessage('操作成功','success')
                this.$emit('onRefreshData')
              } else {
                this.$commonUtils.showMessage((res.message) ? (res.message) : '操作失败,请稍候再试', 'error')
                instance.confirmButtonLoading = false
                instance.confirmButtonText = '保存'
              }
            }).catch(() => {
              instance.confirmButtonLoading = false
              instance.confirmButtonText = '保存'
            })
          } else {
            done()
          }
        }
      }).then(res => {
      }).catch(error => {
      })


    },


    onClose() {
      this.dept_name = '';
      this.dept_id = '';
      this.posts = [];
      this.dept_level = '2';

    },
    onDeletePost(index) {
      this.posts.splice(index, 1)
    },

    onAddPostClick() {
      this.posts.push({
        post_id: '',
        employee_ids: [],
      })
    },


    setData(data) {
      this.show = true;
      this.dept_level = data.dept_level;
      this.dept_name = data.dept_name;
      this.dept_id = data.dept_id;
      this.posts = data.posts;
    },

    showDialog() {
      this.show = true;
    },

    onSelectPostChanged(id, index) {
      this.posts[index].post_id = Number(id);
    },
    onSelectEmployeeChanged(ids, index) {
      this.posts[index].employee_ids = ids;
    }
  }
}
</script>

<style scoped>

</style>
